import React from "react";

import { Box, Typography, ListItem, List, Divider } from "@mui/material";

import Image from "../components/image/Image";
import image from "../resources/images/about/06.jpg";

export default function About(props) {
  const nowMediaQuery = props.nowMediaQuery;
  return (
    <div className="section">
      {/* section 1 */}
      <section className="contents">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          mt={"150px"}
        >
          <Box width={nowMediaQuery !== "mobile" ? "450px" : "250px"} mr={3}>
            <Image
              disabledEffect
              alt={""}
              src={image}
              ratio={"6/4"}
              sx={{ borderRadius: 1 }}
            />
          </Box>
          <Box>
            <Typography
              variant="h4"
              className="bold"
              textAlign={"center"}
              letterSpacing={2}
              fontSize={27}
              mb={1}
            >
              사)길벗사랑 공동체 해피인은
            </Typography>
            <Typography
              variant="subtitle1"
              fontSize={19}
              textAlign={"center"}
              mb={2}
            >
              가난하고 힘겹게 살아가는 취약 독거 중장년 등과 동행하고 지원하며,
              <br />
              지역사회 복지발전을 위해 설립된 사회복지 나눔 공동체입니다.
            </Typography>
            <Box>
              <Typography
                variant="subtitle1"
                fontSize={17}
                className="bold"
                fontWeight={400}
                backgroundColor="#FFE699"
                width={"fit-content"}
                px={3}
                mb={1}
                borderRadius={10}
              >
                비전과 사명
              </Typography>
              <Typography variant="subtitle1" fontSize={17}>
                • 복지사각지대에서 생활고를 겪는 독거 중장년 지원을 통한
                <strong className="blue"> 회복</strong>과{" "}
                <strong className="blue">디딤돌 공동체 형성</strong>
              </Typography>
              <Typography variant="subtitle1" fontSize={17}>
                • 고시원 거주 고위험 독거 중장년 등과의 관계 형성을 통한{" "}
                <strong className="blue">고립 해소</strong>와{" "}
                <strong className="blue">고독사 예방</strong>
              </Typography>
              <Typography variant="subtitle1" fontSize={17}>
                • 당사자 <strong className="blue">자조 자립 공동체 형성</strong>{" "}
                및 <strong className="blue">지원</strong>
              </Typography>
            </Box>
          </Box>
        </Box>
      </section>
      <section className="contents">
        <div>
          <Typography variant="h5" color="black" mb={1}>
            <strong className="blue">지역상황</strong>
          </Typography>
          <Box height={300}>
            <Typography mb={1} variant="subtitle1" fontSize={17}>
              관악구 신림동(현 대학동) 고시촌은 과거 법조인과 고시 수험생이
              3만여 명이 몰려든 인재 등용의 요람이었습니다.
              <br /> 그러나, 사법시험의 폐지 이후 대부분의 이들이 이 지역을
              떠났습니다.
              <br /> 수험생이 잠만 자던 조그마한 고시원은 사시 폐지로 길을 잃은
              중장년들, 가족과 헤어지고 병고와 생활고로 열악한 상황에 몰려
              저렴한 집세를 찾아 모여든 사회적 약자들의 터전이 되었습니다.{" "}
              <br />
              <br />
              현재 대학동은 전국에서 자살율이 가장 높은 고독사 위험군 밀집
              지역입니다.
              <br /> 전체 가구 중 1인 가구 비율이 무려 77.5%에 달하며,
              남성인구는 여성보다 1.6배 많습니다.(2025.1월 기준)
              <br /> 코로나 팬더믹 이후 기초생활수급자 수가 급증했고, 빈곤한
              중장년 남성과 노인들이 산 길을 오르는 윗동네에서 홀로 외롭게
              살아가고 있습니다.
            </Typography>
          </Box>
        </div>
      </section>
      {/* section 3*/}
      <section className="contents">
        <div>
          <Typography variant="h5" mb={1} color="black">
            <strong className="blue">지나온 길</strong>
          </Typography>
          <List sx={{ p: 0 }}>
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                className="bold"
                backgroundColor="lightgray"
                textAlign={"center"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                1993년 ~ 2000년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Typography variant="subtitle1" fontSize={17} mb={0.3}>
                  <strong>
                    난곡동 달동네(신림7동). 재개발로 신림 10동으로 이주
                  </strong>
                </Typography>
                <Typography variant="subtitle1" fontSize={17} mb={0.3} ml={1.5}>
                  - 달동네 주민, 청소년, 청년들 만남과 동행
                </Typography>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                className="bold"
                backgroundColor="lightgray"
                textAlign={"center"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2004년 ~ 2012년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Typography variant="subtitle1" fontSize={17} mb={0.3}>
                  관악구 고시촌 고시수험생 지원{" "}
                  <strong>‘젊은이의 말씀터’</strong>
                </Typography>
                <Typography variant="subtitle1" fontSize={17} mb={0.3} ml={1.5}>
                  - 고시공부로 지치고 방황하고 병들고 자살까지 하는 수험생 만남
                </Typography>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                className="bold"
                backgroundColor="lightgray"
                textAlign={"center"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2012년 ~ 2017년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Typography variant="subtitle1" fontSize={17} mb={0.3}>
                  고시촌 청장년들의 진로 지원{" "}
                  <strong>‘청년인재지원센터’</strong>
                </Typography>
                <Typography variant="subtitle1" fontSize={17} mb={0.3} ml={1.5}>
                  - 사시 폐지로 방황하고 길을 잃은 수험생 청.장년 만남
                </Typography>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                className="bold"
                backgroundColor="lightgray"
                textAlign={"center"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2017년 ~ 현재
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Typography variant="subtitle1" fontSize={17} mb={0.3}>
                  고시촌 독거 중장년들과의 동행
                  <strong> ‘길벗사랑공동체 해피인’</strong>
                </Typography>
                <Typography variant="subtitle1" fontSize={17} mb={0.3} ml={1.5}>
                  - 생활고를 겪는 고독사 위험 독거 중장년 등과의 동행
                </Typography>
              </Box>
            </ListItem>
          </List>
        </div>
      </section>
      <section className="contents">
        <div>
          <Typography variant="h5" color="black" mb={1}>
            <strong className="blue">투명경영</strong>
          </Typography>
          <Box height={300}>
            <Typography variant="subtitle1" fontSize={17}>
              • 해피인은 이웃사랑, 회복, 생명 존중, 나눔의 가치를 실현하기 위해
              노력하고 있습니다.
              <br />• 소외된 이웃에게 안전한 공동체로써 무료급식, 신뢰관계,
              자조공동체 조직, 돌봄을 통한 고독사 예방은 후원자들의 신뢰에
              힘입어 실천하는 우리의 책무성입니다. <br />• 해피인은 앞으로도
              운영의 요소들을 점검하고 개선하며 실행하는 과정을 통해 투명한
              경영과 책임감 있는 후원금 운영을 위해 최선을 다하겠습니다. <br />•
              자체 평가와 운영법인 (사)길벗사랑공동체의 회계 감사를 정기적으로
              수행하며 투명한 회계 집행과 매년 재무정보를 공시합니다. <br />• 년
              2회 해피인의 운영과 재무상황을 담은 회보를 발간하여 후원자와의
              소통을 이어가겠습니다.
            </Typography>
          </Box>
        </div>
      </section>
    </div>
  );
}
